import { useLocalStorage } from '@rehooks/local-storage';
import _ from 'lodash';
import { FUNDING_PARTNERS } from '../types';

type FundingPartnersStorage = {
  viewedPartnerCodes: string[];
};

export const useNewFundingPartners = () => {
  const [fundingPartnersStorage, setFundingPartnersStorage] =
    useLocalStorage<FundingPartnersStorage>('FundingPartners', {
      viewedPartnerCodes: [],
    });
  return {
    newFundingPartners: FUNDING_PARTNERS.filter(
      (x) => !fundingPartnersStorage.viewedPartnerCodes.includes(x.code)
    ),
    setViewedFundingPartners: (codes: string[]) => {
      const newValue = _.uniq([...fundingPartnersStorage.viewedPartnerCodes, ...codes]);
      if (_.isEqual(newValue, fundingPartnersStorage.viewedPartnerCodes)) return;
      setFundingPartnersStorage({
        viewedPartnerCodes: newValue,
      });
    },
  };
};
